// extracted by mini-css-extract-plugin
module.exports = {"reward":"ItemReward_reward__1DX5-","image":"ItemReward_image__3JA7v","title":"ItemReward_title__15Rvc"};